import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { AuthService } from 'app/services/auth.service';
import { inject } from '@angular/core';

// Sirve tanto para canActivate como para canActivateChild: las rutas con hijas (p. ej.
// pricing/quotes/:id) tienen que quedar protegidas igual que la ruta padre.
export const roleGuard = (allowed: string[]): CanActivateFn & CanActivateChildFn => () => {
    const router: Router = inject(Router);
    const userType = inject(AuthService).userType;

    // If the user type is not among the allowed ones...
    if (!allowed.includes(userType)) {
        // Redirect to the 403 page
        return router.parseUrl('403');
    }

    // Allow the access
    return true;
};
